import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import OrganizersSection from './partners/OrganizersSection';
import SponsorsSection from './partners/SponsorsSection';
import SuccessPartnersSection from './partners/SuccessPartnersSection';
import { partnersContent } from './partners/utils';

const PartnersSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('memorial-language') || 'en';
    setCurrentLanguage(savedLanguage);

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'en';
      setCurrentLanguage(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  const content = partnersContent?.[currentLanguage];

  return (
    <section className="py-16 lg:py-24 px-4 bg-[#ce2027]/5">
      <div className="max-w-[1600px] mx-auto">
        {/* Who are we Title */}
        <div id="who-are-we">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="mb-16"
          >
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary text-center">
              {content?.whoAreWeTitle}
            </h2>
          </motion.div>
        </div>

        {/* Organizers Section */}
        <OrganizersSection />

        {/* Sponsors Section */}
        <SponsorsSection />

        {/* Success Partners Section */}
        <SuccessPartnersSection />
      </div>
    </section>
  );
};

export default PartnersSection;